<p-dialog 
  [header]="config.title" 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="config.closable !== undefined ? config.closable : false"
  [style]="dialogStyle"
  [contentStyle]="{'overflow': 'visible', 'padding': '1.5rem'}"
  styleClass="info-dialog">
  <div class="dialog-content">
    <div class="flex align-items-center mb-3">
      <i [class]="config.icon || 'pi pi-info-circle'" [ngStyle]="iconStyle"></i>
      <div class="dialog-message">
        <h4 *ngIf="config.messageTitle" class="m-0 mb-2">{{ config.messageTitle }}</h4>
        <p class="m-0">{{ config.message }}</p>
      </div>
    </div>
  </div>
  <p-footer class="dialog-footer">
    <p-button 
      [label]="config.buttonLabel || 'OK'" 
      [icon]="config.buttonIcon || 'pi pi-check'" 
      (click)="closeDialog()" 
      [style]="{'width': '100%'}">
    </p-button>
  </p-footer>
</p-dialog>

